import * as React from 'react';
import ReactHTMLParser from 'react-html-parser';
import { Text } from '@latitude/text';
import { COLOR, FONT_WEIGHT } from '@latitude/core/utils/constants';
import { StyledAppLinks, AppLinksContainer, AppLink } from './AppLinks.styles';
import AppStoreBadge from './images/badge-app-store.svg';
import GooglePlayBadge from './images/badge-google-play.svg';

var AppLinks = function AppLinks(props) {
  return /*#__PURE__*/React.createElement(StyledAppLinks, null, /*#__PURE__*/React.createElement(Text, {
    color: COLOR.BLACK,
    fontWeight: FONT_WEIGHT.BOLD,
    fontSize: "17px"
  }, props.data.downloadLabel ? ReactHTMLParser(props.data.downloadLabel) : 'Download the Latitude Credit Card App'), /*#__PURE__*/React.createElement(AppLinksContainer, null, /*#__PURE__*/React.createElement(AppLink, {
    href: props.data.appleLink || 'https://itunes.apple.com/app/apple-store/id1373059866',
    target: "_blank",
    "data-trackid": "footer-itunes-app-link",
    noStyle: true,
    trackEventData: {
      label: 'App Store'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: AppStoreBadge,
    alt: "Download on the AppStore"
  })), /*#__PURE__*/React.createElement(AppLink, {
    href: props.data.googleLink || 'https://play.google.com/store/apps/details',
    target: "_blank",
    "data-trackid": "footer-googleplay-app-link",
    noStyle: true,
    trackEventData: {
      label: 'Google Play'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: GooglePlayBadge,
    alt: "Get it on Google Play"
  }))));
};

export default AppLinks;